var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-content" },
    [
      _c("text-area-row", {
        attrs: {
          title: "AidTargetYearlyReport.ExternalServices.AcquisitionOrService",
          id: "Acquisition-" + _vm.index,
          required: true,
          maxLength: 500,
          rows: 5
        },
        model: {
          value: _vm.item.description,
          callback: function($$v) {
            _vm.$set(_vm.item, "description", $$v)
          },
          expression: "item.description"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: "AidTargetYearlyReport.ExternalServices.Source",
          id: "Source-" + _vm.index,
          required: true,
          maxLength: 100,
          rows: 1
        },
        model: {
          value: _vm.item.source,
          callback: function($$v) {
            _vm.$set(_vm.item, "source", $$v)
          },
          expression: "item.source"
        }
      }),
      _vm._v(" "),
      _c("radio-button-row", {
        attrs: {
          title:
            "AidTargetYearlyReport.ExternalServices.RelatedPartyAcquisition",
          required: true,
          componentIndex: _vm.index
        },
        model: {
          value: _vm.item.relatedPartyAcquisition,
          callback: function($$v) {
            _vm.$set(_vm.item, "relatedPartyAcquisition", $$v)
          },
          expression: "item.relatedPartyAcquisition"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "AidTargetYearlyReport.ExternalServices.Price",
          id: "Price-" + _vm.index,
          required: true
        },
        model: {
          value: _vm.item.price,
          callback: function($$v) {
            _vm.$set(_vm.item, "price", $$v)
          },
          expression: "item.price"
        }
      }),
      _vm._v(" "),
      _c("radio-button-option-row", {
        attrs: {
          title: "AidTargetYearlyReport.ExternalServices.TenderStatus",
          required: true,
          options: _vm.optionsArray("TenderStatus", true),
          componentIndex: _vm.index
        },
        model: {
          value: _vm.item.tenderStatus,
          callback: function($$v) {
            _vm.$set(_vm.item, "tenderStatus", $$v)
          },
          expression: "item.tenderStatus"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }